import axios from 'axios';
import qs from 'qs';

import config from 'utils/config';

class Loqate {
  httpClient = null;

  baseURL = '';

  findURL = config('LOQATE_FIND_URL');

  retrieveURL = config('LOQATE_RETRIEVE_URL');

  constructor(key, baseUrl) {
    this.baseURL = baseUrl || config('LOQATE_BASE_URL');
    this.httpClient = axios.create({
      baseURL: this.baseURL,
      params: {
        Key: key
      },
      paramsSerializer: (params) =>
        qs.stringify(params, {
          arrayFormat: 'comma'
        })
    });
  }

  static create(key, baseUrl) {
    return new Loqate(key, baseUrl);
  }

  retrieve(id) {
    return this.httpClient.get(this.retrieveURL, {
      params: {
        Id: id
      }
    });
  }

  find(query) {
    const { text, containerId, language } = query;

    return this.httpClient.get(this.findURL, {
      params: {
        Text: text,
        Container: containerId,
        language
      }
    });
  }
}

export default Loqate;
